/* Cafe Passport cart helpers: one-request adds, free sticker sync, drawer refresh. */
(function () {
  if (window.CPCart) return;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var MAP = {};
  try { MAP = JSON.parse(document.getElementById('cp-sticker-map').textContent) || {}; } catch (e) {}

  function isBook(it) { return /passport/i.test(it.product_type || '') && it.requires_shipping !== false; }
  // Gift stickers use the same _cp_gift tag your SMART Functions discount looks for.
  function isFree(it) { var p = it.properties || {}; return !!(p._cp_gift || p._cp_free); }
  function json(url, body) {
    return fetch(ROOT + url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); });
  }
  // Cart is read in the background so a click only needs one request.
  var cached = null;
  function prefetch() { cached = null; json('cart.js').then(function (c) { cached = c; }).catch(function () {}); }
  function getCart() { if (cached) { var c = cached; cached = null; return Promise.resolve(c); } return json('cart.js'); }
  function drawer() { return document.querySelector('cart-drawer'); }
  function sectionIds() {
    var d = drawer();
    if (d && d.getSectionsToRender) return d.getSectionsToRender().map(function (s) { return s.id; });
    return ['cart-drawer', 'cart-icon-bubble'];
  }
  // Rapid Bundle or other apps already handling gifts: stay out of the way.
  function otherGiftApp(items) {
    return items.some(function (it) {
      if (isFree(it)) return false;
      var props = it.properties || {};
      return Object.keys(props).some(function (k) { return /^_?rapi/i.test(k); });
    });
  }
  function plan(items, adding) {
    var all = items.concat(adding || []), total = 0, want = {};
    all.forEach(function (it) {
      if (!isBook(it)) return;
      total += it.quantity;
      var s = MAP[it.product_type];
      if (s) want[s] = (want[s] || 0) + it.quantity;
    });
    if (total < 2) want = {};
    var lines = {};
    items.forEach(function (it) {
      if (!isFree(it)) return;
      var v = String(it.variant_id);
      (lines[v] = lines[v] || []).push(it);
    });
    var add = [], updates = {}, n = 0;
    var vs = Object.keys(want).concat(Object.keys(lines).filter(function (v) { return !want[v]; }));
    vs.forEach(function (v) {
      var w = want[v] || 0, ls = lines[v] || [];
      var h = ls.reduce(function (a, it) { return a + it.quantity; }, 0);
      if (!ls.length) { if (w) add.push({ id: +v, quantity: w, properties: { _cp_gift: '1' } }); return; }
      if (h === w && ls.length === 1) return;
      ls.forEach(function (it, i) { var q = i === 0 ? w : 0; if (it.quantity !== q) { updates[it.key] = q; n++; } });
    });
    return { add: add, updates: updates, hasUpdates: n > 0 };
  }
  function render(state) {
    var d = drawer();
    if (d && d.renderContents && state && state.sections) {
      try { d.classList.remove('is-empty'); d.renderContents(state); } catch (e) {}
      afterRender();
    } else if (!d) {
      window.location.href = ROOT + 'cart';
    }
  }
  function sections() {
    return fetch(ROOT + '?sections=' + sectionIds().join(','), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (s) { return { sections: s }; });
  }
  // Make free sticker lines match the books in the cart. Resolves once the cart is correct.
  function fixStickers(cart) {
    if (otherGiftApp(cart.items)) return Promise.resolve(false);
    var p = plan(cart.items, []);
    var chain = Promise.resolve(false);
    if (p.hasUpdates) chain = chain.then(function () { return json('cart/update.js', { updates: p.updates }).then(function () { return true; }); });
    if (p.add.length) chain = chain.then(function () { return json('cart/add.js', { items: p.add }).then(function () { return true; }); });
    return chain;
  }
  function afterRender() {
    if (window.cpShipBanner) window.cpShipBanner();
  }
  function announce(state) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cp', cartData: state }); } catch (e) {}
    }
  }

  // lines: [{id, quantity, product_type, requires_shipping}]
  function add(lines) {
    return getCart().then(function (cart) {
      var p = otherGiftApp(cart.items) ? { add: [], updates: {}, hasUpdates: false } : plan(cart.items, lines);
      var items = lines.map(function (l) { return { id: l.id, quantity: l.quantity }; }).concat(p.add);
      var body = { items: items };
      if (!p.hasUpdates) body.sections = sectionIds();
      return json('cart/add.js', body).then(function (res) {
        if (!p.hasUpdates) return res;
        return json('cart/update.js', { updates: p.updates, sections: sectionIds() });
      });
    }).then(function (state) { render(state); announce(state); prefetch(); return state; },
      function (err) { prefetch(); throw err; });
  }

  var syncing = false;
  function sync() {
    if (syncing) return Promise.resolve();
    syncing = true;
    return json('cart.js').then(fixStickers)
      .then(function (changed) { if (changed) return sections().then(render); })
      .catch(function () {}).then(function () { syncing = false; prefetch(); });
  }

  window.CPCart = { add: add, sync: sync };

  function hook() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) { if (!e || e.source !== 'cp') { cached = null; setTimeout(sync, 0); } });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hook); else hook();
  (window.requestIdleCallback || function (f) { setTimeout(f, 300); })(prefetch);
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') prefetch(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) prefetch(); });

  function loading(on) { var i = document.querySelector('[data-cpd]'); if (i) i.classList.toggle('is-loading', on); }
  function change(key, q) {
    loading(true);
    syncing = true;
    return json('cart/change.js', { id: key, quantity: Math.max(0, q) })
      .then(fixStickers)
      .catch(function () {})
      .then(function () { return sections().then(render); })
      .catch(function () { window.location.reload(); })
      .then(function () { syncing = false; loading(false); prefetch(); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cpd-qty]');
    if (!b) return;
    e.preventDefault();
    change(b.dataset.cpdQty, +b.dataset.q);
  });

  // Add buttons inside the drawer (recommendations)
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cp-drawer-add]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    loading(true);
    add([{ id: +b.dataset.cpDrawerAdd, quantity: 1, product_type: b.dataset.type || '', requires_shipping: true }])
      .catch(function () { b.disabled = false; b.textContent = 'Try again'; });
  });
})();
